import React from 'react'

import styles from './Box.module.css'

export default ({ title, subtitle, tintColor, textColor, image, height, link }) => {
  const containerStyle = {
    backgroundColor: tintColor,
    height: height + 'px'
  }

  const backgroundStyle = {
    backgroundImage: `url(${image})`,
  }

  const textStyle = {
    color: textColor
  }

  return (

    <div className={styles.container} style={containerStyle}>
      <a href={link}>
        <div className={styles.background} style={backgroundStyle} />
        <div className={styles.spacer} />
        <div className={styles.content}>
          <span className={styles.title} style={textStyle}>{title}</span>
          <span className={styles.subtitle}  style={textStyle}>{subtitle}</span>
        </div>
      </a>
    </div>

  )
}



// WEBPACK FOOTER //
// ./src/components/Box.js